function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import OkCancelDialog from "../ok-cancel-dialog/OkCancelDialog";
import PortalTextInput from "../../form-elements/portal-text-input/PortalTextInput";
const useStyles = makeStyles({
  deleteWrapper: {
    maxWidth: 300,
    display: "flex",
    marginTop: 16,
    flexDirection: "column"
  }
});
const DestructiveOkCancelDialog = ({
  children,
  ...rest
}) => {
  const [deleteText, setDeleteText] = React.useState("");
  const handleTextChange = React.useCallback(event => setDeleteText(event.target.value));
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(OkCancelDialog, _extends({
    okDisabled: deleteText !== "DELETE",
    okDisabledTooltip: "Type DELETE to confirm"
  }, rest), children, /*#__PURE__*/React.createElement(PortalTextInput, {
    containerClass: classes.deleteWrapper,
    name: "deleteText",
    label: "Type DELETE to confirm",
    value: deleteText,
    onChange: handleTextChange,
    placeholder: "",
    id: "deleteTextInputField",
    background: "white",
    autoFocus: true,
    autoComplete: "off"
  }));
};
export default DestructiveOkCancelDialog;
DestructiveOkCancelDialog.propTypes = {
  children: PropTypes.node
};